export const visitorSiteConfig = {
  siteId: "allta",
  siteName: "ALLTA",
  excludedPathPrefixes: [],
} as const;
